import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderDetails, PaymentMethod, paymentOptions, StripeBankTransferInstructions } from 'libs/shared/src/lib/models/order';
import { HelpersService } from 'libs/shared/src/lib/services/helpers.service';
import { OrdersService } from 'libs/shared/src/lib/services/orders.service';
declare var Stripe: any; // : stripe.StripeStatic;

@Component({ standalone: false,
  selector: 'vfa-cp-contract-payment-card',
  templateUrl: './contract-payment-card.component.html',
  styleUrls: ['./contract-payment-card.component.scss']
})

export class ContractPaymentCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() paymentMethods: PaymentMethod[] = [];
  @Input() isAutoRenewal!: boolean;
  @Input() isAutorenewalAsset!: boolean;
  @Input() isOnboardingPayment!: boolean;
  @Input() order!: any;
  @Input() years: any;
  @Input() price: any;
  @Input() rest: number = 0;
  @Input() orderId: any;
  @Input() assetId: any;
  @Input() waitResolvePay: any;
  public stripe: any;
  public waitPay: boolean = false;
  public waitSave: boolean = false;
  @Output() onWaitSave: EventEmitter<any> = new EventEmitter();
  public waitStripeLoaded : boolean = false;
  @Output() onWaitStripeLoaded: EventEmitter<any> = new EventEmitter();
  @Output() onCanPayChange: EventEmitter<any> = new EventEmitter();
  @Output() onStartPaymentError: EventEmitter<any> = new EventEmitter();
  @Output() onConfirmPayment: EventEmitter<any> = new EventEmitter();
  @Output() onCompleteForm: EventEmitter<any> = new EventEmitter();
  public canPay: boolean = false;
  public elements: any;
  payButtonLabel: string | null = null;
  customInfoText: string | null = null;
  customPayment: boolean = false;
  public formCompleted: boolean = false;
  public autorenewal = false;
  public autorenewalMessage: string = '';
  public selectedPaymentMethod!: any;
  public PAYMENT_METHOD_KEY_PREFIX: string = '';
  public PAYMENT_INFO_FIRST: string = '';
  public bankTransferInstructions!: StripeBankTransferInstructions;
  private confirmPaymentResponse: any = null;
  public REGISTRATION_COUNTRY_PREFIX: string = '';
  public ONBOARDING_AUTORENEWAL_FOR_DURATIONS: any = null;
  private paymentFormSubmitHandler: ((event: Event) => void) | null = null;

  constructor(public ordersService: OrdersService, public helpersService: HelpersService, private activatedRoute: ActivatedRoute, private modalService: NgbModal, private currencyPipe: CurrencyPipe) {
  }

  get discount() {
    if (localStorage.getItem(this.ordersService.storageDiscountKey)) {
      const disc = localStorage.getItem(this.ordersService.storageDiscountKey);
      return Number(disc) > 0 ? String(this.ordersService.instant('order-discount', { $1: disc })) : null;
    }
    return null
  }

  ngOnInit() {
    this.PAYMENT_METHOD_KEY_PREFIX = this.ordersService.config?.PAYMENT_METHOD_KEY_PREFIX || 'payment-method-';
    this.PAYMENT_INFO_FIRST = this.ordersService.config?.PAYMENT_INFO_FIRST || 'payment-info-first-';
    this.REGISTRATION_COUNTRY_PREFIX = this.helpersService.config?.REGISTRATION_COUNTRY_PREFIX || 'registration-country-';
    this.ONBOARDING_AUTORENEWAL_FOR_DURATIONS = this.helpersService.config?.ONBOARDING_AUTORENEWAL_FOR_DURATIONS || 36;
    this.paymentMethods.forEach(method => method.selectable = true);
    if(this.isOnboardingPayment && this.order && this.order.is_automatic_renewal_available && this.order.automatic_renewal) {
      this.changeAutorenewalChecked(this.order.automatic_renewal);
    }
    if (this.paymentMethods && this.paymentMethods.length === 1) {
      this.init(this.paymentMethods[0]);
    }
  }

  ngOnChanges(changes: any) {
    if (changes?.paymentMethods && this.paymentMethods?.length === 1) {
      if (this.paymentMethods && this.paymentMethods.length === 1) {
        this.init(this.paymentMethods[0]);
      }
    }
  }

  changeAutorenewalChecked(e: any) {
    if(e) {
      let count = 0;
      this.paymentMethods.forEach(method => {
        if(method.automatic_renewal) {
          count++;
        } else {
          method.selectable = false;
        }
      });
      if(count === 1) {
        this.selectedPaymentMethod = this.paymentMethods.filter(method => method.selectable === true)[0];
      }
    } else {
      this.paymentMethods.forEach(method => method.selectable = true);
      this.selectedPaymentMethod = null;
    }
  }

  cancelPaymentIntent() {
    this.detachPaymentFormSubmitHandler();
    this.selectedPaymentMethod = null;
    this.canPay = false;
    this.payButtonLabel = null;
    this.customInfoText = null;
    this.waitStripeLoaded = false;
    this.onWaitStripeLoaded.emit(this.waitStripeLoaded);
    this.onCanPayChange.emit(this.canPay);
    if(this.isOnboardingPayment && this.order && this.order.is_automatic_renewal_available && this.order.automatic_renewal) {
       this.changeAutorenewalChecked(this.order.automatic_renewal);
    }
   
  }

  init(method: any) {
    // TODO temporary fix to ensure both flows are consistent
    this.selectedPaymentMethod = method;
    if (!method.payment_method_type || method.payment_method_type === null) {
      this.customPayment = true;
      return;
    }
    this.waitPay = true;
    this.canPay = true;
    this.onCanPayChange.emit(this.canPay);
    const methodTag = method.payment_method_type.replace("_", "-");
    this.createPayButtonLabel(methodTag);
    const req = { 'payment_method_id': method.id , "automatic_renewal": false };
    if(this.isOnboardingPayment) {
      req.automatic_renewal = this.order.automatic_renewal;
    } else if(this.isAutoRenewal && !this.isOnboardingPayment && !this.isAutorenewalAsset) {
      req.automatic_renewal = true;
    }
    this.customInfoText = this.ordersService.instant(this.PAYMENT_METHOD_KEY_PREFIX + methodTag + '-info');
    this.createIntent(method, req);
  }

  private createIntent(method: any, req: any) {
    if(this.isAutoRenewal && this.isAutorenewalAsset && this.assetId) {
      this.ordersService.createSubscriptionIntent(this.assetId, method.id).subscribe((res: any) => {
        if (res && res.account_id) {
          this.startPayment(method.payment_method_type, res.account_id, res.client_secret);
        }
      }, err => {
        this.onStartPaymentError.emit(false);
        this.helpersService.showToast(this.helpersService.getError(err), "danger")
      })
    } else {
      this.ordersService.createPaymentIntent(this.orderId, req).subscribe((res: any) => {
        if (res && res.account_id) {
          this.startPayment(method.payment_method_type, res.account_id, res.client_secret);
        }
      }, err => {
        this.onStartPaymentError.emit(false);
        this.helpersService.showToast(this.helpersService.getError(err), "danger");
        this.waitPay = false;
      })
    }
  }

  startPayment(paymentMethod: string, accountId: string, client_secret: string) {
    const form = document.getElementById('payment-form');
    const method = this.selectedPaymentMethod.payment_method_type.replace("_", "-");
    // this.price = new Intl.NumberFormat(this.helpersService.lang.replace('_', '-'), { style: 'currency', currency: this.order.NE__OrderId__r.CurrencyIsoCode }).format(this.order.NE__OrderId__r.NE__One_Time_Fee_Total__c)
    this.createPayButtonLabel(method);
    this.detachPaymentFormSubmitHandler();
    this.paymentFormSubmitHandler = (e: Event) => {
      e.preventDefault();
      if (this.ordersService.config.STRIPE_METHOD_CUSTOMER_BALANCE && paymentMethod === this.ordersService.config.STRIPE_METHOD_CUSTOMER_BALANCE && this.confirmPaymentResponse) {
        // this.payButtonLabel = this.ordersService.instant('order-detail-payment-action-confirm');
        this.confirmPayment(this.confirmPaymentResponse?.paymentIntent?.id)
      } else if (this.ordersService.config.STRIPE_METHOD_SEPA_DEBIT && paymentMethod === this.ordersService.config.STRIPE_METHOD_SEPA_DEBIT) {
        this.createTokenSepa(this.elements);
      } else {
        // this.payButtonLabel = this.ordersService.instant('order-detail-payment-action-finalize', {$1: price});
        this.createToken(this.elements);
      }
    };
    form?.addEventListener('submit', this.paymentFormSubmitHandler);
    this.payment(accountId, client_secret, this.selectedPaymentMethod.payment_method_type);
    if (this.stripe && this.ordersService.config.STRIPE_METHOD_CUSTOMER_BALANCE && paymentMethod === this.ordersService.config.STRIPE_METHOD_CUSTOMER_BALANCE) {
      this.createTokenCustomerBalance(client_secret);
    }
  }

  payment(accountId: string, client_secret: string, method: string) {
    const options = {
      stripeAccount: accountId,
      locale: this.ordersService.getCroppedLang(this.ordersService.lang)
    }
    this.stripe = Stripe(this.ordersService.config.STRIPE_PLATFORM_PK, options);

    const appearance = {
      theme: 'stripe',
    };
    this.elements = this.stripe.elements({ appearance, clientSecret: client_secret });

    // Payment
    const optionsForPayment: any = paymentOptions[method];
    if(this.isAutoRenewal && this.isAutorenewalAsset && this.assetId) {
      this.ordersService.getCustomerInfo(this.orderId, method).subscribe(res => {
        optionsForPayment.defaultValues = res;
        this.mountStripeEl(optionsForPayment);
      }, err => {
        this.mountStripeEl(optionsForPayment);
        this.ordersService.showToast(this.helpersService.getError(err), 'danger');
      })
    } else {
      this.mountStripeEl(optionsForPayment);
    }
  }

  private mountStripeEl(optionsForPayment: any) {
    this.waitPay = false;
    const paymentElement = this.elements.create('payment',
      optionsForPayment
    );
    paymentElement.mount('#payment-element');
    paymentElement.on('ready', (event :any) => {
      this.waitStripeLoaded = true;
      this.onWaitStripeLoaded.emit(this.waitStripeLoaded);
    })
    paymentElement.on('change', (event: any) => {
      this.formCompleted = event.complete;
      this.onCompleteForm.emit(event.complete);
    });
    paymentElement.addEventListener('change', (event: any) => {
      let displayError = document.getElementById('error-message');
      if (displayError) {
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      }
    });
  }

  private createTokenCustomerBalance(client_secret: any) {
    this.waitSave = true;
    this.onWaitSave.emit(this.waitSave);
    this.stripe.confirmCustomerBalancePayment(
      client_secret,
      {
        payment_method: {
          customer_balance: {},
        }
      },
      {
        handleActions: false,
      }
    ).then((res: any) => {
      if (res.error) {
        // Inform the customer that there was an error.
        this.waitSave = false;
        this.onWaitSave.emit(this.waitSave);
        this.ordersService.showToast(res.error.message, 'danger');
      } else if (res.paymentIntent.status === 'requires_payment_method') {
        // If `payment_method_options.funding_type` wasn't set this
        // is where you would need to handle the insufficient customer
        // balance state.
      } else if (res.paymentIntent.status === 'requires_action') {
        // If the current customer balance is insufficient to cover
        // the amount, and you've passed
        // `payment_method_options.funding_type` for funding the
        // customer balance, you can display the bank transfer
        // instructions to your user.
        if (res.paymentIntent.next_action.type === 'display_bank_transfer_instructions') {
          // Bank transfer details can be found under:
          // res.paymentIntent.next_action.display_bank_transfer_instructions
          this.bankTransferInstructions = res.paymentIntent.next_action.display_bank_transfer_instructions;
          this.confirmPaymentResponse = res;
          this.waitSave = false;
        }
      }
    });
  }

  private createTokenSepa(elements: any) {
    this.waitSave = true;
    this.onWaitSave.emit(this.waitSave);
    this.stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: "http://example.com",
      },
      redirect: 'if_required'
    }
    ).then((res: any) => {
      if (res.error) {
        // Inform the customer that there was an error.
        this.waitSave = false;
        this.onWaitSave.emit(this.waitSave);
        this.ordersService.showToast(res.error.message, 'danger');
      } else {
        this.waitSave = false;
        this.confirmPayment(res.setupIntent.id);
      }
    });
  }

  private createToken(elements: any) {
    this.waitSave = true;
    this.onWaitSave.emit(this.waitSave);
    if(this.isAutoRenewal) {
      this.stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: "http://example.com",
        },
        redirect: 'if_required'
      }).then((res: any, paymentIntent: any) => {
        if (res.error) {
          this.waitSave = false;
          this.onWaitSave.emit(this.waitSave);
          this.ordersService.showToast(res.error.message, 'danger');
        } else {
          this.waitSave = false;
          this.confirmPayment(res.setupIntent.id)
        }
      })
    } else {
      this.stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: "http://example.com",
        },
        redirect: 'if_required'
      }).then((res: any, paymentIntent: any) => {
        if (res.error) {
          this.waitSave = false;
          this.onWaitSave.emit(this.waitSave);
          this.ordersService.showToast(res.error.message, 'danger');
        } else {
          this.waitSave = false;
          this.confirmPayment(res.paymentIntent.id)
        }
      })
    }
  }

  public confirmCustomPayment() {
    if(this.paymentMethods?.[0]?.id) {
      this.confirmPayment(this.paymentMethods?.[0]?.id);
    } else {
      const msg = this.helpersService.instant("common-error-no-data");
      this.ordersService.showToast(msg, 'danger');
    }
  }

  private confirmPayment(intent: any) {
    if(this.isOnboardingPayment) {
      const req = {
        intent: intent,
        automatic_renewal: this.order.automatic_renewal
      }
      this.onConfirmPayment.emit(req);
    } else {
      this.onConfirmPayment.emit(intent);
    }
  }

  private createPayButtonLabel(methodTag: string) {
    // this.payButtonLabel = this.ordersService.instant('order-detail-payment-action-confirm');
    if(this.isAutoRenewal) {
      this.payButtonLabel = this.ordersService.instant('save-SEPA-autorenewal-button');
    } else {
      this.payButtonLabel = this.ordersService.instant(this.PAYMENT_METHOD_KEY_PREFIX + methodTag + '-cta', { $1: this.price });
    }
  }

  private detachPaymentFormSubmitHandler() {
    const form = document.getElementById('payment-form');
    if (form && this.paymentFormSubmitHandler) {
      form.removeEventListener('submit', this.paymentFormSubmitHandler);
    }
    this.paymentFormSubmitHandler = null;
  }
  
  ngOnDestroy(): void {
    this.detachPaymentFormSubmitHandler();
  }
}
